/**
 * Shared helpers for Scope 3 (and similar) documentation tables backed by `/documents` APIs.
 */

import { formatReportingDateGhgEntry } from "./formatDate";

function normalizeReportingEndForDisplay(end) {
  if (end == null || end === "") return end;
  let datePart;
  if (typeof end === "string") {
    datePart = end.split("T")[0];
  } else if (end instanceof Date && !Number.isNaN(end.getTime())) {
    const y = end.getFullYear();
    const mo = String(end.getMonth() + 1).padStart(2, "0");
    const d = String(end.getDate()).padStart(2, "0");
    datePart = `${y}-${mo}-${d}`;
  } else {
    return end;
  }
  const m = /^(\d{4})-04-01$/.exec(datePart);
  if (!m) return end;
  return `${m[1]}-03-31`;
}

export function formatReportingPeriod(row) {
  const startRaw =
    row?.reportingStart ??
    row?.reportingPeriodStart ??
    row?.reportingPeriodStartDate;
  const endRaw =
    row?.reportingEnd ??
    row?.reportingPeriodEnd ??
    row?.reportingPeriodEndDate;

  if (startRaw && endRaw) {
    const end = normalizeReportingEndForDisplay(endRaw);
    const startStr = formatReportingDateGhgEntry(startRaw);
    const endStr = formatReportingDateGhgEntry(end);
    if (startStr && endStr) return `${startStr} - ${endStr}`;
  }
  const rp = row?.reportingPeriod;
  if (typeof rp === "string" && rp.trim()) return rp.trim();
  return "";
}

/**
 * `TableDocument` uses `value || columnKey`; coerce blank values to "N/A" so the key is not shown.
 * @param {unknown} value
 * @returns {string}
 */
export function displayDocumentationCell(value) {
  if (value == null) return "N/A";
  const t = String(value).trim();
  return t === "" ? "N/A" : t;
}
